import React, { useEffect } from "react";
import { graphql, Link } from "gatsby";
import SEO from "~/views/components/generic/seo";
import structuredData from "~/helpers/structured-data";
import Frame from "~/views/layout/frame";
import Header from "~/views/compositions/navigation/header";
import Page from "~/models/page";
import FlowType from "~/models/flow-type";
import Breadcrumb from "~/views/compositions/navigation/breadcrumb";

type Props = {
  data: Queries.FlowTypeListPageQuery;
};

const FlowTypeListPage = ({ data }: Props) => {
  const page = new Page(data.page as any);

  const types = data.types.nodes.map((type) => new FlowType(type as any));

  useEffect(() => {
    document.getElementsByTagName("body")[0].classList.remove("preventXScroll");
  }, []);

  return (
    <Frame>
      <Header />

      <div className="bg-neutral-99">
        <Breadcrumb
          breadcrumb={page.breadcrumb}
          className="max-w-screen-xl !px-5 lg:!px-14"
        />

        <div className="max-w-screen-xl px-5 lg:px-14 mx-auto pt-12 pb-80">
          <h2 className="text-2xl text-neutral-30 font-bold mb-8">
            ユーザーフロー
          </h2>
          <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-x-8 gap-y-10">
            {types.map((type: any) => (
              <li
                key={type.id}
                className="font-medium text-xs text-neutral-60 hover:highlighted-link">
                <Link to={`/explore/types/${type.slug}`}>{type.name}</Link>
              </li>
            ))}
            <li
              key="others"
              className="font-medium text-xs text-neutral-60 hover:highlighted-link">
              <Link to={`/explore/types/others`}>その他</Link>
            </li>
          </ul>
        </div>
      </div>
    </Frame>
  );
};

export default FlowTypeListPage;

export const Head = ({ data }: Props) => {
  const page = new Page(data.page as any);
  const sd = structuredData(page);

  return <SEO page={page} sd={sd} noindex />;
};

export const query = graphql`
  query FlowTypeListPage {
    page: pageMdx(
      filter: { frontmatter: { url: { pathname: { eq: "/explore/types/" } } } }
    ) {
      frontmatter {
        id
        title
        description
        breadcrumb {
          ...UrlFields
        }
        url {
          ...UrlFields
        }
        type
        releasedAt
        updatedAt
        image {
          ...AssetFields
        }
      }
    }
    types: allFlowTypeYaml(
      filter: { slug: { nin: ["others"] } }
      sort: { yamlId: ASC }
    ) {
      nodes {
        id
        yamlId
        slug
        name
      }
    }
  }
`;
